import {request} from "./request";

export const getWorld = queryParams => {
  return request.get({
    path: "/engine/world/info",
    queryParams,
  });
};

export const getWorldList = queryParams => {
  return request.get({
    path: "/engine/world/list",
    queryParams,
  });
};

export const createWorld = params => {
  return request.post({
    path: "/engine/world/create",
    params,
  });
};

export const updateWorld = (queryParams, params) => {
  return request.put({
    path: "/engine/world/update",
    queryParams,
    params,
  });
};

export const viewWorld = params => {
  return request.patch({
    path: "/engine/world/view",
    params,
  });
};

export const uploadWorldThumbnail = params => {
  return request.post({
    path: "/engine/world/thumbnail/upload",
    params,
  });
};

export const uploadWorldScene = params => {
  return request.post({
    path: "/engine/world/scene/upload",
    params,
  });
};
